export const BASE_CLASS = 'metric-list';
export const STATE_KEY = 'metricList';

export const SCROLL_TRIGGER_ID = 'metricListScroll';
